export default {
  title: 'AJINGA+ Download and Installation Guide',
  content: 'Download the AJINGA+ resume sourcing widget (Chrome browser only) to streamline your direct resume sourcing work on popular China job boards such as 51job.com, Liepin.com and Zhaopin.com. AJINGA+ empowers you to automatically import candidate profiles with just a few simple clicks, without navigating away from the job board. You can also ensure PIPL compliance with automated candidate consent notifications options. Download and install AJINGA+ from the Chrome APP Store (recommended) or download the installation file directly from AJINGA to get started today!',
  optionFirst: 'Option 1:',
  optionSecond: 'Option 2:',
  downloadHead: 'Download from ',
  chromeStore: 'Chrome Web Store',
  downloadTail: '',
  downloadFromPackage: 'Installation Package Download',
  downloadForMac: 'Download for Mac OS',
  downloadForWindows: 'Download for Windows',
  or: 'OR'
}
